import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const AmountServer = {
    Channel: {
        /**
         * 获取主计划列表
         */
        list: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/master_plan/page`,
                params
            );
        },
        /**
         * 创建主计划
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/master_plan`, params);
        },
        /**
         * 修改主计划
         */
        modify: (params: any) => {
            return axios.put(
                `${ADMIN_API_ROOT}/master_plan/${params.id}`,
                params
            );
        },
        /**
         * 获取主计划详情
         */
        detail: (params: { id: string | number }) => {
            return axios.get(`${ADMIN_API_ROOT}/master_plan/${params.id}`);
        },
        /**
         * 删除主计划
         */
        delete: (params: { ids: string[] | [] }) => {
            return axios.delete(
                `${ADMIN_API_ROOT}/master_plan/batch_delete`,
                { params }
            );
        },
        enabled: async (params: { id: string | number; enabled: boolean }) => {
            return axios.put(
                `${ADMIN_API_ROOT}/price_level/${params.id}/${params.enabled ? "enabled" : "disabled"
                }`,
                {}
            );
        },
    },
    Recharge: {
        /**
         * 充值列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/recharge/list`,
                { params }
            );
        },
        /**
         * 充值审核
         */
        approve: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/recharge/check`,
                params
            );
        },
        // 获取充值网络类型列表
        networkType: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/config/wallet-network-select`,
                { params }
            );
        },

        queryAccountSumbit: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/recharge/search-entry`,
                params
            );
        },
    },
    Withdrawal: {
        /**
         * 提现列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/withdraw/list`,
                { params }
            );
        },
        /**
         * 提现审核
         */
        approve: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/withdraw/check`,
                params
            );
        },
    },
    BalanceLog: {
        /**
         * 用户余额变更日志
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/list`,
                { params }
            );
        },
        /**
         * 余额变动场景列表
         */
        scene: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/scene-list`,
                { params }
            );
        },
        /**
         * 余额变动状态列表
         */
        status: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/status-list`,
                { params }
            );
        },
        /**
         * 余额变动类型列表
         */
        track: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/track-id-list`,
                { params }
            );
        },
        export: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/export`,
                {
                    params,
                    headers: { "content-type": "application/json; charset=utf-8", },
                    responseType: "blob",
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
            );
        },
    },
    UserAddress: {
        // 用户地址列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/member/address-list`,
                { params }
            );
        },
        // 删除用户钱包地址
        delete: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/member/address-delete`,
                { params }
            );
        },
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/member/address-update`,
                params
            );
        },
    },
    NetWorktransfer: {
        // 用户转账列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/recharge/network-transfer-record`,
                { params }
            );
        },
        // 获取网络转账状态列表
        statusList: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/recharge/status-select-list`
            )
        },
    }
}